import {Component, Inject, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {DOCUMENT} from '@angular/common';

@Component({
    selector: 'app-ready-for-solar',
    templateUrl: './ready-for-solar.component.html',
    styleUrls: ['./ready-for-solar.component.scss']
})
export class ReadyForSolarComponent implements OnInit {

    constructor(@Inject(DOCUMENT) public document: Document,
                private router: Router) {
    }

    ngOnInit(): void {
    }

    continue(): void {
        this.router.navigate(['/main/build/selection']);
    }
}
